import { render, staticRenderFns } from "./Lineup.vue?vue&type=template&id=1371bb05&"
import script from "./Lineup.vue?vue&type=script&lang=js&"
export * from "./Lineup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports